import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Observable, Subscriber } from 'rxjs/Rx';
import { environment } from '../../../../../environments/environment';
import { HttpService } from './http.service';

@Injectable()
export class ApplicationApi {
  // handleError: any;
  admindocumentdetails(userid: any, app_id: any) {
    throw new Error('Method not implemented.');
  }
 
  private readonly apiController: string = 'application';

  constructor(private api: HttpService,
    private http: HttpClient) { }

  get(url: string): Observable<any> {
    return new Observable((observer: Subscriber<any>) => {
      let objectUrl: string = null;
      this.http
        .get(url, {
          responseType: 'blob'
        })
        .subscribe(m => {
          objectUrl = URL.createObjectURL(m);
          observer.next(objectUrl);
        });

      return () => {
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
          objectUrl = null;
        }
      };
    });
  }

  applicationdata(id) {
    return this.http.get(`${environment.apiUrl}/application/applicationdata?id=` + id)
  }
  
  getApplication(id) {
    return this.http.get(`${environment.apiUrl}/application/getApplication?id=` + id)
  }

  //Pending Applications
  //to get all the "pending" students in student dashboard
  getAll_PendingApplications(page,id,name, email, type) {
    return this.http.get(`${environment.apiUrl}/application/pending_students?page=${page}&id=${id}&name=${name}&email=${email}&type=${type}`);
  }

  //view student details
  getAdminSideDetails(id, app_id) {
    return this.http.get(`${environment.apiUrl}/application/getAdminSideDetails?id=${id}&app_id=${app_id}`)
  }

  //Verified Application
  getAll_verifiedApplications(page, name, email) {
    return this.http.get(`${environment.apiUrl}/application/verified_students?page=${page}&name=${name}&email=${email}`);
  }

  generateCertificate(userId, app_id, adminEmail) {
    return this.http.post(`${environment.apiUrl}/application/generateCertificate`, { "userId": userId, "app_id": app_id, "adminEmail": adminEmail });
  }

  // Signed Application
  getAll_signedApplications(page, name, email, type) {
    return this.http.get(`${environment.apiUrl}/application/signed_students?page=${page}&name=${name}&email=${email}&type=${type}`);
  }

  checksignedpdf(id, userId) {
    return this.http.get(`${environment.apiUrl}/application/checksignedpdf?id=${id}&userId=${userId}`);
  }

  sendemail(id, userId, adminEmail) {
    return this.http.post(`${environment.apiUrl}/application/sendEmail`, { id: id, userId: userId, "adminEmail": adminEmail });
  }

  getVerificationLetters(id, userId) {
    return this.http.get(`${environment.apiUrl}/application/getVerificationLetters?id=${id}&userId=${userId}`)
  }

  // Sent Applications
  getAll_emailedApplications(page, name, email) {
    return this.http.get(`${environment.apiUrl}/application/emailed_students?page=${page}&name=${name}&email=${email}`);
  }

  setApplicationErrata(event, id, user_id, type, app_id, message) {
    return this.http.post(`${environment.apiUrl}/application/setApplicationErrata`, { event: event, id: id, user_id: user_id, type: type, app_id: app_id, message: message });
  }

  getInstituteAddress(id, userId, dataValues) {
    return this.http.get(`${environment.apiUrl}/application/getInstituteAddress?id=${id}&userId=${userId}&section=${dataValues}`)
  }

  downloadExcel(tracker, type,startDate,endDate) {
    return this.http.get(`${environment.apiUrl}/application/downloadExcel?tracker=${tracker}&type=${type}&startDate=${startDate}&endDate=${endDate}`)
  }

  downloadFiles(documentFile): Observable<Blob> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.apiUrl}/application/downloadFiles?documentFile=` + documentFile, { headers: headers, responseType: 'blob' }).map(
      (res) => {
        return new Blob([res], { type: 'application/pdf' });
      });

  }
  //3
  setResolve(id, email, value) {
    return this.http.post(`${environment.apiUrl}/application/setResolve`, { "id": id, "email": email, "value": value });
  }
  //1
  getallpedingpayment(page, date, email, value) {
    return this.http.get(`${environment.apiUrl}/application/getallpedingpayment?page=${page}&date=${date}&email=${email}&value=${value}`);

  }
  //4
  getAll_Paydetails(page,id,name,email,order_id,bank_ref_no){
    
    return this.http.get(`${environment.apiUrl}/application/getAll_Paydetails?page=${page}&id=${id}&name=${name}&email=${email}&order_id=${order_id}&bank_ref_no=${bank_ref_no}`);
  }

  downloadExcel_date(startDate, endDate) {

    try {
      return this.http.get(`${environment.apiUrl}/application/downloadExcel_date?startDate=` + startDate + '&endDate=' + endDate)
    } catch (error) {

    }
  }

  //2
  getPaymentDetails(tab_type) {

    return this.http.get(`${environment.apiUrl}/application/getPaymentDetails?tab_type=` + tab_type);

  }
  //5
  getPaymentdeatils(value) {
    return this.http.get(`${environment.apiUrl}/application/getPaymentdeatils?value=${value}`);

  }

  //getall student
  getallstudents(page, name, email) {
    return this.http.get(`${environment.apiUrl}/application/students?page=${page}&name=${name}&email=${email}`);
  }

  //status
  status(status, userId) {
    return this.http.put(`${environment.apiUrl}/application/status`, { "status": status, "userId": userId });

  }

  //verifyotp
  verifyOtp(otp, email, userId) {
    return this.http.put(`${environment.apiUrl}/application/verifyOtp`, { "otp": otp, "email": email, "userId": userId });
  }

  //getallstudentfeedback
  getallstudentfeedback() {
    return this.http.get(`${environment.apiUrl}/application/student_feeback`);
  }

  getSubAdminData(userId) {
    return this.http.get(`${environment.apiUrl}/application/role_management/getSubAdminData?userId=` + userId);

  }

  addUpdatesubAdmin(userId, subAdminData) {
    return this.http.post(`${environment.apiUrl}/application/role_management/addUpdatesubAdmin`, { "userId": userId, "subAdminData": subAdminData });

  }

  getRolesData(userId) {
    return this.http.get(`${environment.apiUrl}/application/role_management/getRolesData?userId=` + userId);

  }

  faq() {
    return this.http.get(`${environment.apiUrl}/application/help`)
    
  }

  createData(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}/application/help`, data);
  }

  deleteAppId(user_id){ 
    try{
      return this.http.get(`${environment.apiUrl}/application/deleteAppId?user_id=${user_id}`);
    }catch(error){
      this.handleError('deleteAppId: ' + JSON.stringify(error))
    }
  }

  addupdateRole(roles,superroles,source_array,activity,user_id){
    try{
      return this.http.post(`${environment.apiUrl}/application/role_management/setUpdateRole`,{"roles":roles,"superroles":superroles,"source_array":source_array,"activity":activity,"user_id":user_id});
    }catch(error) {
        this.handleError("addupdateRole : "+JSON.stringify(error));
    }
  }
  changeSubAdminStatus(userId) {
    return this.http.post(`${environment.apiUrl}/application/role_management/changeSubAdminStatus`, { "userId": userId });

  }

  getallsubadmin(name,email){
    try{
      return this.http.get(`${environment.apiUrl}/application/role_management/main?name=`+name+`&email=`+email);
    }catch(error) {
      this.handleError("getallsubadmin : "+JSON.stringify(error));
    }
  }

  regeneratePdf(appl_id, user_id, reg_reason, admin_email) {
    return this.http.get(`${environment.apiUrl}/application/regeneratePdf?user_id=${user_id}&appl_id=${appl_id}&reg_reason=${reg_reason}&email_admin=${admin_email}`);
  }

  getMenuRole(userID) {
    return this.http.get(`${environment.apiUrl}/application/role_management/getMenuRole?userID=` + userID);
  }

  getTotalApplications(page, id, name, email, year) {
    return this.http.get(`${environment.apiUrl}/application/total?page=${page}&id=${id}&name=${name}&email=${email}&acadYear=${year}`);

  }

  
  handleError(arg0: string) {
    throw new Error('Method not implemented.');
  }

  saveNotes(id, notes) {
    try {
      return this.http.post(`${environment.apiUrl}/application/saveNotes`, { id: id, notes: notes });
    } catch (error) {
      this.handleError("saveNotes : " + JSON.stringify(error));
    }
  }

  getFileData(page, date) {
    return this.http.get(`${environment.apiUrl}/application/getFileData?page=${page}&date=${date}`);
  }

  downloadFileExcel(date) {
    return this.http.get(`${environment.apiUrl}/application/downloadFileExcel?date=${date}`);
  }

  getPortalwaiseApplicationCount() {
    return this.http.get(`${environment.apiUrl}/application/getPortalwaiseApplicationCount`);
  }

  activitytracker(page, date, data, email) {
    return this.http.get(`${environment.apiUrl}/application/adminDashboard/activitytracker?page=${page}&date=${date}&data=${data}&email=${email}`);

  }

 downloadDocs(app_id,userId,type){
    if(type == 'ApplicationForm'){
      return this.http.post(`${environment.apiUrl}/application/generatepdfform`, {'app_id': app_id, "user_id": userId});
    }else if(type=='mergedDocuments'){
      return this.http.get(`${environment.apiUrl}/payment/mergeDocuments?app_id=${app_id}&user_id=${userId}`);
    }
  }

  verifyparticularDocuments(app_id,user_id,checked,type,doc_id,outward){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/verifyparticularDocuments`,{app_id : app_id,user_id : user_id,checked:checked,type:type  ,doc_id : doc_id, outward: outward});
    }catch(error) {
      this.handleError("verifyparticularDocuments : "+JSON.stringify(error));
    }
  }

  saveOutward(app_id,outward,source,user_id,type,letterFormat,email){
    try{
      return this.http.post(`${environment.apiUrl}/${this.apiController}/saveOutward`,{app_id : app_id,outward : outward,source:source,user_id : user_id,type: type,letterFormat : letterFormat,email : email});
    }catch(error) {
      this.handleError("saveOutward : "+JSON.stringify(error));
    }
  }

  downloadDocuments(documentFile):Observable<Blob>{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.apiUrl}/${this.apiController}/downloadDocuments?documentFile=`+documentFile, { headers: headers, responseType: 'blob'}).map(
    (res) => {
        return new Blob([res], { type: 'application/pdf' });
    });
  }

  savePersonalForm(personalDetails,userId){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/updateStudentDetails`,{userId:userId, personalDetails:personalDetails});
  }

  getCourseDetails(course,pattern){
    return this.http.get(`${environment.apiUrl}/${this.apiController}/courseDetails?course=${course}&pattern=${pattern}`)
  }

  saveInsDetails(data,email){

    return this.http.post(`${environment.apiUrl}/${this.apiController}/saveInsDetails`,{errataDetails : data,email:email});
  }

  saveEduDetails(data,email){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/saveEduDetails`,{errataDetails : data,email:email});
  }

  getColleges(){
    try{
      return  this.http.get(`${environment.apiUrl}/${this.apiController}/getColleges`);
    }catch(error){
      this.handleError("getCourses: "+JSON.stringify(error));
    }
  }

  getCourses(){
    try{
      return  this.http.get(`${environment.apiUrl}/${this.apiController}/getCourses`);
    }catch(error){
      this.handleError("getCourses: "+JSON.stringify(error));
    }
  }

  getAllEmailData(page,to_email,subject){
    try{
      return this.http.get(`${environment.apiUrl}/${this.apiController}/getAllEmailActivityTracker?page=${page}&to_email=${to_email}&subject=${subject}`);
    }catch(err){
      this.handleError("getAllEmailData :"+JSON.stringify(err));
    }
  }

  saveAddDetails(documentDetailsData){
    return this.http.post(`${environment.apiUrl}/${this.apiController}/saveAddDetails`,{documentDetailsData : documentDetailsData});
  }
 

} 